import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import ObaNotificacaoModel from "../model/ObaNotificacaoModel";

type ModalNewAppProps = {
  notificacao: ObaNotificacaoModel;
  visivel: boolean;
  fechar: any;
};

type ModalNewAppState = {
  enabled: boolean;
};


class ModalNewApp extends React.Component<
    ModalNewAppProps,
    ModalNewAppState
> {

  private urlIOS = "https://apps.apple.com/br/app/oba-hortifruti/id1489610018";
  private urlAndroid = "https://play.google.com/store/apps/details?id=com.redeoba.ObaLoja";
  
  constructor(props: ModalNewAppProps) {
    super(props);

    this.fechar = this.fechar.bind(this);
  }

  fechar(): any {
    if (this.props.fechar) {
      this.props.fechar();
    }
  }

  render(): any {

    const { notificacao } = this.props;

    if (notificacao) {
      let urlApp:string = "";

      if(/Android/i.test(navigator.userAgent)){
        urlApp = this.urlAndroid;
      } else if(/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        urlApp = this.urlIOS;
      }

      const days = notificacao.disponivelAte.getDate() - new Date().getDate();
  
      return (
        <Dialog id="newapp" open={this.props.visivel}>
          <DialogContent>
            <div dangerouslySetInnerHTML={{ __html: notificacao.html
              .replace('{link}', urlApp)
              .replace('{days}', days.toString())
            }}></div>
            { !notificacao.blocante &&
            <div className="menu">
              <button onClick={this.fechar}>X</button>
            </div>
            }
          </DialogContent>
        </Dialog>
      );
    } else {
      return <></>;
    }
  }
}

export default ModalNewApp;
